export enum EAiModelStatus {
  Active = 0,
  Deprecated = 1,
  Shutdown = 2
}
